import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { ConfigFacade } from '@library/store/config/config.facade';
import { EnumEnvs } from '@library/store/config/config.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { isDefined } from "@library/utils/helpers/store/is-defined";
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import {
  SUPPORTED_CONTROL_ENERGY_MODULES,
  SUPPORTED_CONTROL_GATEWAYS,
  SUPPORTED_CONTROL_WEATHER_MODULES,
  SUPPORTED_HEATING_ENERGY_REPORT,
} from "@pages/control-page/control-page.const";
import { UIFacade } from '@store/ui/ui.facade';
import { EnumSidebarButtons } from '@store/ui/ui.state';
import * as moment from 'moment-timezone';
import { combineLatest } from "rxjs";
import { map } from 'rxjs/operators';
import { NetatmoTypes } from 'src/assets/consts/App.constants';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {

  EnumSidebarButtons = EnumSidebarButtons;
  EnumEnvs = EnumEnvs;
  environment = environment;

  helpCenterUrl$ = this.modulesFacade.currentHomeModules$.pipe(
    map((modules) => {
      const netatmoHelpCenterUrl = "https://helpcenter.netatmo.com/hc/articles/17751713445138";
      // By default, we pass the Netatmo helpCenterURL to not block
      if (modules?.length > 0){
        /**
         * If any Netatmo modules, go to Netatmo helpcenter
         * Else, go to Legrand helpcenter
         */
        const hasNetatmoModule = modules.some((module: Module) => {
          return NetatmoTypes.includes(module.type);
        });
        return hasNetatmoModule ? netatmoHelpCenterUrl : 'https://qna.legrand.com/home-control';
      }
      else {
        return netatmoHelpCenterUrl;
      }
    })
  );

  hasReportsSubLink$ = this.modulesFacade.currentHomeModules$.pipe(
    isDefined(),
    map((modules) => {
      return modules.some((module: Module) => {
        return SUPPORTED_HEATING_ENERGY_REPORT.includes(module.type);
      });
    })
  );

  hasCompareSubLink$ = this.modulesFacade.currentHomeModules$.pipe(
    isDefined(),
    map(modules => modules.some(m => [
      ...SUPPORTED_CONTROL_GATEWAYS,
      ...SUPPORTED_CONTROL_ENERGY_MODULES,
      ...SUPPORTED_CONTROL_WEATHER_MODULES].includes(m.type))),
  );

  hasCompareOrReportsSubLink$ = combineLatest([
    this.hasCompareSubLink$,
    this.hasReportsSubLink$
  ]).pipe(
    map(([hasCompareSubLink, hasReportsSubLink]) => hasCompareSubLink || hasReportsSubLink)
  );

  constructor(
    private configFacade: ConfigFacade,
    public uiFacade: UIFacade,
    private modulesFacade: ModulesFacade,
    private location: Location,
    private localStorageService: LocalStorageService
  ) {}

  isControlActive() {
    return this.location.path().includes('/control/');
  }

  isAssistant() {
    return this.location.path().includes('/control/assistant');
  }

  hasSeenFusCompare() {
    return !this.localStorageService.getItem('control-fus-seen-compare');
  }

  hasSeenBilan() {
    return !this.localStorageService.getItem('control-seen-bilan');
  }

  hasSeenNews() {
    return !this.localStorageService.getItem('control-seen-news') && moment().isBefore('2024-06-03');
  }

}
